export const colors = Object.freeze({
  canvas: "#F5F2EE",
  surface: "#FFFFFF",
  surfaceSubtle: "#FAF8F5",
  surfaceRaised: "#FFFFFF",
  border: "#E8E2D9",
  borderStrong: "#D9D2C8",
  text: "#1A1714",
  textSecondary: "#6B6460",
  textMuted: "#8A827C",
  primary: "#2D6A4F",
  primaryDark: "#1E4D38",
  primaryMid: "#52B788",
  primarySubtle: "#E8F4EE",
  warm: "#C17B3A",
  warmSubtle: "#FBF1E6",
  info: "#2F5D8C",
  infoSubtle: "#EAF2FA",
  danger: "#A13D3D",
  dangerSubtle: "#FBECEC",
  focus: "#245EA8",
});

export const radii = Object.freeze({
  control: 10,
  card: 16,
  sheet: 20,
  pill: 999,
});

export const shadows = Object.freeze({
  card: "0 2px 8px rgba(26, 23, 20, 0.06)",
  raised: "0 12px 32px rgba(26, 23, 20, 0.10)",
});

export const layout = Object.freeze({
  touchTarget: 44,
  feedMaxWidth: 680,
  pageMaxWidth: 1200,
  mobileGutter: 12,
  desktopGutter: 24,
});

export const typography = Object.freeze({
  sans: "'DM Sans', -apple-system, BlinkMacSystemFont, sans-serif",
  serif: "'DM Serif Display', Georgia, serif",
  mono: "'DM Mono', ui-monospace, monospace",
});

export const privacyAudience = Object.freeze({
  PRIVATE: {
    shortLabel: "Only me",
    description: "Visible only to you",
    tone: "neutral",
  },
  FRIENDS: {
    shortLabel: "Friends",
    description: "Visible to accepted friends",
    tone: "info",
  },
  CIRCLE: {
    shortLabel: "Circle",
    description: "Visible to members of this Circle",
    tone: "primary",
  },
  CHURCH: {
    shortLabel: "Church",
    description: "Visible to permitted Church members",
    tone: "primary",
  },
  SHARED: {
    shortLabel: "Life Circle community",
    description: "Visible to eligible Life Circle members, beyond your friends and Circles",
    tone: "warm",
  },
});
